export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const FORM_RESET_PASSWORD = 'FORM_RESET_PASSWORD';
export const FORM_RESET_PASSWORD_SUCCESS = 'FORM_RESET_PASSWORD_SUCCESS';
export const FORM_RESET_PASSWORD_FAILED = 'FORM_RESET_PASSWORD_FAILED';
